// Module
var code = "<div aria-id=\"not-authorized-page\"> <div class=\"row\"> <div class=\"col-md-12\" style=\"padding:50px;text-align:center!important\"> <h1 style=\"color:#ff4500;font-size:6rem;text-transform:uppercase\">Not authorized.</h1> <h3>If you feel you've reached this page in error, please contact Help Desk. </h3></div> </div> </div>";
// Exports
export default code;